import React__default, { memo } from 'react';
import { LogoLoader } from '../logo/index.js';
import { Progress } from '../progress/index.js';
import { Provider } from '../provider/index.js';
import { LoaderContent } from '../loader-content/index.js';

var LoadingComp = function (_a) {
    var progress = _a.progress, logo = _a.logo;
    return (React__default.createElement(LoaderContent, { logoRenderer: React__default.createElement(LogoLoader, { src: logo }), progressRenderer: React__default.createElement(Progress, { progress: progress }), providerRenderer: React__default.createElement(Provider, null) }));
};
LoadingComp.displayName = 'Loading';
var Loading = memo(LoadingComp);

export { Loading };
